export const appendServiceToUrl = (url: string, service: string) => {
    return url.endsWith(service) ? url : `${url}${service}`;
}